export default "__VITE_ASSET__DsKrlX14__"